import React from 'react';
import {Row, Col} from 'reactstrap';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';

const OtpHeadlineComponent = (props) => {
    return (
            <div className={`otp-headline-wrapper`}>
                    <Col className={`${isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'col-12': ''} otp-headline-title ${props.businessOtp ? 'suitcase':'phone'}`}> {props.title} </Col>
                {props.description &&
                    <Col className={`otp-headline-description bold ${isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'col-12': ''} p-0`}>{props.description }</Col>
                }
                {props.codeEnterText &&
                    <Col className = {`otp-headline-codeEnter bold ${isMobile ? 'col-12  p-0': ''}`}>{props.codeEnterText}</Col>
                }
            </div>
    )
}
export default OtpHeadlineComponent;